<template>
  <div class="bg">
    <div class="container">
      <div class="row justify-content-between align-items-center">
        <div class="col-md nav-link d-none d-md-block">
          <div>
            <img src="@/assets/receptionist.jpg" alt class="img-fluid" />
          </div>
        </div>
        <div class="col-md">
          <div class="mb-5">
            <div class="text-center">
              <img class="px-1" src="@/assets/ikolilu.png" height="100px" alt="logo" />
              <h2 class="mb-0">for providers</h2>
            </div>
            <div class="card-body">
              <div class="container text-left">
                <form @submit.prevent="submit">
                  <div class="form-group mb-2">
                    <label>Email</label>
                    <input
                      v-model="provider.useremail"
                      type="email"
                      class="form-control"
                      aria-describedby="emailHelp"
                      placeholder="provider@ikolilu.com"
                      required
                    />
                  </div>
                  <div class="form-group mb-1">
                    <label>Password</label>
                    <input
                      v-model="provider.userpass"
                      type="password"
                      class="form-control"
                      aria-describedby="passwordHelp"
                      placeholder="********"
                      required
                    />
                  </div>
                  <!-- <div class="row justify-content-end px-3">
                    <div><router-link to="/enroll">Sign Up</router-link></div>
                    <div>
                      <a href>Forgot your password?</a>
                    </div>
                  </div> -->
                  <div class="animated fadeIn text-center py-4">
                    <button
                      type="submit"
                      id="login-btn"
                      class="btn btn-outline-success"
                      :disabled="loading"
                    >
                      <i
                        v-if="loading"
                        :class="['fa', 'fa-spin', 'fa-spinner', loading?'loading-width':'']"
                      ></i>
                      <template v-else>SIGN IN</template>
                    </button>
                  </div>
                  <!-- <p class="text-center">Sign in with</p> -->
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/network/Base.js";
import login from "@/network/user/signin.js";

export default {
  name: "clogin",
  data() {
    return {
      loading: false,
      isLoggingIn: false,
      provider: {
        useremail: "",
        userpass: ""
      }
    };
  },
  methods: {
    submit() {
      this.loading = true;
      login.userSignIn(this, http(), this.provider);
    }
  },
  created() {
    // autofill
    if (this.$route.query["useremail"]) {
      this.provider.useremail = this.$route.query["useremail"];
    }
  }
};
</script>

<style scoped>
.bg {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  height: 100vh;
}
.card {
  background-color: #ffffff;
}
label {
  font-weight: bold;
}
#login-btn {
  transition: 200ms width;
  width: 250px;
}
.loading-width {
  width: 50px !important;
}
</style>
